<template>
  <div
    v-if="!searching"
    class="c-search"
  >
    <p class="c-search__caption">
      {{ $t('search.results') }} "{{ keyword }}"
    </p>
    <ui-results
      :products="products"
      :recommends="recommends"
    ></ui-results>
  </div>
</template>
<script>
  import { Search } from '@/shared/libs/sdk';
  import { getSubscriberRating, isKey, keyMap } from '@/shared/utils';
  import UiResults from './results.vue';

  export default {
    components: {
      UiResults,
    },
    data() {
      return {
        service: new Search(),
        keyword: '',
        recommends: {}, // TODO: new Sections({ label: 'searchengine' }),
        resource: {},
        products: null,
        searching: true,
        subscriber: this.$services.resolve('subscriber'),
      };
    },
    mounted() {
      document.addEventListener('keydown', this.keyHandle);
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.keyHandle);
    },
    methods: {
      search(keyword) {
        const maxRating = getSubscriberRating(this.subscriber.dateOfBirth);

        this.searching = true;
        this.keyword = keyword;
        this.$spinner.show();
        this.$stats.search(keyword);

        return this.service.fetchAll({
          clips: true,
          episodes: true,
          keyword: keyword.toLowerCase(),
          kids: this.subscriber.isKidsTheme,
          maxRating,
        })
          .then((items) => {
            this.products = items;
          })
          .catch(() => {})
          .then(() => {
            this.$spinner.hide();
            this.searching = false;
          });
      },
      close() {
        this.resource = {};
        this.products = null;
      },
      keyHandle(e) {
        if (isKey(keyMap.ESCAPE, e)) {
          this.close();
        }
      },
    },
  };
</script>
